import '@/helpers/polyfills'
import RestClient from '@/utils/rest-client';
import { CbError } from '@/hosted_fields/common/errors'
import EnvConstants, { isDev } from '@/constants/environment';
import { ApiInterface, ApiClientInterface, ApiConfigInterface, ApiActionInterface, BUSINESS_ENTITY_HEADER } from '@/plugins/core/api/interface'
import CommManagerInterface from '@/hosted_fields/master/interface';
import { isCbDomain } from '@/utils/utility-functions';

const commonApis: ApiInterface[] = [
];

export default class ApiClient implements ApiClientInterface {

  public _config: ApiConfigInterface;
  private restClient: RestClient;
  private staticClient: RestClient;
  private commMgr: CommManagerInterface;

  constructor(commMgr: CommManagerInterface) {
    // TODO: Throw error on config
    this.commMgr = commMgr;
    this._config = {
      site: commMgr.site,
      hostName: commMgr.hostName,
      publishableKey: commMgr.publishableKey,
      customDomain: commMgr.site_meta.options.domain,
    }
    this.restClient = new RestClient({ baseURL: this.getDomain() });
    this.staticClient = new RestClient({ baseURL: this.getStaticDomain() })
    this.addApis(commonApis)
  }

  getStaticDomain(): string {
    let domain = EnvConstants.STATIC_DOMAIN || this.getDomain()
    return domain.replace("${site}", this._config.site)
  }

  getDomain(): string {
    if (isDev()) {
      if (this._config.customDomain) {
        const customDomains = this._config.customDomain.split(',')
        try {
          const customDomain = customDomains[0]
          const url = new URL(customDomain)
          return url.origin
        } catch (e) {
          console.error(new Error(`Invalid custom domain ${this._config.customDomain}`))
        }
      }
    }
    return isCbDomain(this._config.hostName) ? this._config.hostName : EnvConstants.APP_DOMAIN.replace("${site}", this._config.site)
  }

  doRecaptchaValidation(apiName: string, action: ApiActionInterface): Promise<any> {
    if (!action.recaptcha) {
      return Promise.resolve();
    } else {
      return this.commMgr.getCheckoutUtilsPlugin()
      .then(checkoutUtilsPlugin => checkoutUtilsPlugin.getInfo())
      .then(() => {
        if (this.commMgr.recaptchaKey) {
          return this.commMgr.initiateRecaptcha(`${apiName}_${action.name}`);
        }
      })
    }
  }

  addApis(apis: ApiInterface[]) {
    var that = this;
    apis && apis.length && apis.forEach(api => {
      this[api.name] = {};
      api.actions.forEach(action => {
        this[api.name][action.name] = function (args) {
          var urlEndPoint = ApiClient.getEndpoint(action, Array.prototype.shift.apply(arguments));
          var finalArgs = [].slice.call(arguments);
          finalArgs.unshift(urlEndPoint);
          if (finalArgs.length == 1) {
            finalArgs.push({});
          }

          const [_url, _payload = {}, _options = {}] = finalArgs;
          var headers = {};
          if (action.headers && Object.keys(action.headers).length >= 0) {
            Object.assign(headers, action.headers);
          }

          if (action.jsApi) _payload['_jsapi_key'] = that._config.publishableKey;
          if (that._config.publishableKey) headers['Authorization'] = `Basic ${that._config.publishableKey}`;
          if (that.commMgr.businessEntityId && !action.skipBusinessEntityId) headers[BUSINESS_ENTITY_HEADER] = that.commMgr.businessEntityId;

          if (_options && _options.headers) {
            Object.assign(headers, _options.headers)
          }

          return that.doRecaptchaValidation(api.name, action)
            .then((recaptchaToken: string) => new Promise((resolve, reject) => {
              if (action.static && action.method != "get") {
                console.warn('Use GET HTTP method for static domain')
              }
              if(recaptchaToken) _payload.recaptchaToken = recaptchaToken;

              (
                action.static
                  ? that.staticClient[action.method].apply(that.staticClient, [_url, _payload, headers])
                  : that.restClient[action.method].apply(that.restClient, [_url, _payload, headers])
              ).then(response => {
                resolve(response.data);
              }).catch((error) => {
                reject(new CbError(error));
              });
            }));
        }
      });
    });
  }

  private static getEndpoint(action: ApiActionInterface, params) {
    if (typeof action.endpoint === 'string') {
      return action.endpoint;
    } else {
      var sanitizedParams = params && Object.keys(params).reduce((o, param) => {
        if (params[param]) {
          o[param] = encodeURIComponent(params[param]).replace(/%2F/g, '/');
        }
        return o;
      }, {});
      return action.endpoint(sanitizedParams);
    }
  }
}
